document.addEventListener('DOMContentLoaded',function(){
  var button=document.querySelector('[data-mobile-toggle]');
  var drawer=document.querySelector('[data-mobile-drawer]');
  if(!button||!drawer)return;
  function setOpen(open,restoreFocus){
    drawer.classList.toggle('is-open',open);
    drawer.hidden=!open;
    button.setAttribute('aria-expanded',String(open));
    button.setAttribute('aria-label',open?button.dataset.closeLabel:button.dataset.openLabel);
    if(restoreFocus)button.focus();
  }
  button.addEventListener('click',function(){setOpen(drawer.hidden,false);});
  drawer.addEventListener('click',function(event){if(event.target.closest('a'))setOpen(false,false);});
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&!drawer.hidden){setOpen(false,true);}
  });
  document.addEventListener('click',function(event){
    if(!drawer.hidden&&!drawer.contains(event.target)&&!button.contains(event.target))setOpen(false,false);
  });
  var desktop=window.matchMedia('(min-width:990px)');
  desktop.addEventListener('change',function(event){if(event.matches)setOpen(false,false);});
});
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-email-draft]').forEach(function(form){
    var ready=form.querySelector('[data-email-ready]');
    var preview=form.querySelector('[data-email-preview]');
    var open=form.querySelector('[data-email-open]');
    if(!ready||!preview||!open)return;
    function updateDraft(){
      var valid=Array.from(form.elements).every(function(field){return !field.willValidate||field.validity.valid;});
      ready.hidden=!valid;
      if(!valid){
        preview.value='';
        open.href='mailto:johnny@erastatic.com';
        return false;
      }
      var lines=[];
      var subject=form.dataset.emailSubject;
      Array.from(form.elements).forEach(function(field){
        if(!field.name||!field.name.startsWith('contact['))return;
        var label=field.name.slice(8,-1);
        var value=field.type==='checkbox'?(field.checked?field.value:'No'):field.value.trim();
        if(label==='Era / Subject'&&value)subject=subject+' — '+value;
        if(value)lines.push(label+': '+value);
      });
      var body=lines.join('\n\n');
      preview.value=body;
      open.href='mailto:johnny@erastatic.com?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
      return true;
    }
    open.addEventListener('click',function(event){
      if(!form.reportValidity()||!updateDraft())event.preventDefault();
    });
    form.addEventListener('submit',function(event){
      event.preventDefault();
      if(form.reportValidity()&&updateDraft())open.click();
    });
    form.addEventListener('input',updateDraft);
    form.addEventListener('change',updateDraft);
    updateDraft();
  });
});
